import { render, staticRenderFns } from "./Form19Table.vue?vue&type=template&id=531c067b"
import script from "./Form19Table.vue?vue&type=script&lang=ts"
export * from "./Form19Table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports